import React, { useContext, useState, useEffect, useRef } from "react";
import { useForm, FormProvider } from "react-hook-form";
import FormInput from "../../../components/FormInput";
import { validationRules } from "../../../utils/validationRules";
import { Stepper, Step, StepLabel } from "@mui/material";
import { Row, Col, Button } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import {
  createPersonalLoan,
  getPersonalLoanByEmail,
  getAllCities,
  getPersonalLoanByMobile,
  getAllStates,
  getAllPincode,
  getAllCompanies,
  getAllPersonalLoanBanks,
  getPersonalLoanBankList,
  createOrGetCustomer
} from "../../../middleware/backend_hepler";
import { AuthContext } from "../../../Context/AuthContext";
import { toast, ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import SelectInput from "../../../components/SelectInput";
import DropDownInput from "../../../components/DropDownInput";
import { FaTrashAlt } from "react-icons/fa";
import CreateCompanyModal from "../Company/CreateComapnyModal";


const CreatePersonalForm = () => {
  const { adminId, adminName, isLoggedIn, adminRole } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);
  const [states, setStates] = useState([]);
  const [filteredStates, setFilteredStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [cityOptions, setCityOptions] = useState([]);
  const [pincodenumber, setPincode] = useState([]);
  const [pincodeOptions, setPincodeOptions] = useState([]);
  const [selectedState, setSelectedState] = useState(null);
  const [presentState, setPresentState] = useState(null);
  const [presentCityOptions, setPresentCityOptions] = useState([]);
  const [presentPincodeOptions, setPresentPincodeOptions] = useState([]);
  const [officeState, setOfficeState] = useState(null);
  const [officeCityOptions, setOfficeCityOptions] = useState([]);
  const [officePincodeOptions, setOfficePincodeOptions] = useState([]);
  const [companyLists, setCompanyLists] = useState([]);
  const [bankLists, setBankLists] = useState([]);
  const [selectedCompanyId, setSelectedCompanyId] = useState([]);
  const [companyName, setCompanyName] = useState([]);
  const [personalLoanBanks, setPersonalLoanBanks] = useState([]);
  const [files, setFiles] = useState({});
  const [isViewModalOpen, setIsViewModalOpen] = useState(false);
  
  const navigate = useNavigate();
  const methods = useForm({ mode: "onChange", reValidateMode: "onChange" });
  const {
    handleSubmit,
    register,
    watch,
    trigger,
    setValue,
    formState: { errors, isValid },
  } = methods;
  const [emailExists, setEmailExists] = useState(false);
  const [mobileExists, setMobileExists] = useState(false);
  const [activeStep, setActiveStep] = useState(0);

  const fileRefs = {
    pan: useRef(null),
    aadhar: useRef(null),
    photo: useRef(null),
    pay_slip: useRef(null),
    account_statement: useRef(null),
    others: useRef(null),
  };  

  const steps = ["Personal Details", "Income Details", "Upload Documents"];

  const handleStepChange = async (newStep) => {
    if (newStep > activeStep) {
      const isValid = await trigger();
      if (isValid) {
        if (emailExists) {
          toast.error("Email already exists. Please use a different email.");
          return;
        }

        if (mobileExists) {
          toast.error(
            "Mobile number already exists. Please use a different mobile number."
          );
          return;
        }

        setActiveStep(newStep);
      }
    } else {
      setActiveStep(newStep);
    }
  };

  const fetchCompanies = async () => {
    try {
      const response = await getAllCompanies();
      const companyData = response.data.map((company) => ({
        value: company.company_id,
        label: company.company_name,
      }));
      companyData.sort((a, b) => a.label.localeCompare(b.label));
      setCompanyLists(companyData);
    } catch (error) {
      console.error("Error fetching companies:", error);
    }
  };

  useEffect(() => {
    fetchCompanies();
  }, []);

  useEffect(() => {
    if (!selectedCompanyId) return;
    if (
      !selectedCompanyId ||
      (Array.isArray(selectedCompanyId) && selectedCompanyId.length === 0)
    ) return; const fetchCompanyByIdWithBanks = async () => {
      try {
        const response = await getAllPersonalLoanBanks(selectedCompanyId);

        const bankList = response.data.bank_list;

        const formattedBanks = bankList.map((bank) => ({
          value: bank.bank_name,
          label: bank.bank_name,
        }));

        setBankLists(formattedBanks);
      } catch (error) {
        console.error("Error fetching bank:", error);
      }
    };

    fetchCompanyByIdWithBanks();
  }, [selectedCompanyId]);

  useEffect(() => {
    const fetchPersonalLoanBanks = async () => {
      try {
        const response = await getPersonalLoanBankList();
        const banksData = response.data.map(bank => ({
          value: bank.bank_name,
          label: bank.bank_name
        }));
        banksData.sort((a, b) => a.label.localeCompare(b.label));
        setPersonalLoanBanks(banksData);
      } catch (error) {
        console.error("Error fetching personal loan banks:", error);
      }
    };
    fetchPersonalLoanBanks();
  }, []);

  useEffect(() => {
    const fetchStates = async () => {
      try {
        const statesData = await getAllStates();
        const availableStates = statesData.filter(
          (state) => state.availability === "Yes"
        );
        setStates(availableStates);
        setFilteredStates(availableStates);
      } catch (error) {
        console.error("Error fetching states data:", error);
      }
    };
    fetchStates();
  }, []);

  const stateOptions = filteredStates.map((state) => ({
    value: state.name,
    label: state.name,
  }));

  useEffect(() => {
    const fetchCities = async () => {
      try {
        const citiesData = await getAllCities();
        citiesData.sort((a, b) => a.name.localeCompare(b.name));
        setCities(citiesData);
      } catch (error) {
        console.error("Error fetching cities:", error);
      }
    };
    fetchCities();
  }, []);

  useEffect(() => {
    const fetchPinCode = async () => {
      try {
        const pincodeData = await getAllPincode();
        setPincode(pincodeData);
      } catch (error) {
        console.error("Error fetching pincodes:", error);
      }
    };
    fetchPinCode();
  }, []);

  useEffect(() => {
    if (!selectedState) {
      setCityOptions([]);
      setPincodeOptions([]);
    } else {
      const filteredCities = cities.filter(
        (city) => city.State_name === selectedState
      );

      const cityOptions = filteredCities.map((city) => ({
        value: city.name,
        label: city.name,
      }));
      setCityOptions(cityOptions);

      const filteredPincodes = pincodenumber.filter(
        (pincode) => pincode.state === selectedState.toUpperCase()
      );

      const uniquePincodes = new Set();
      const uniqueOptions = [];
      filteredPincodes.forEach((pincode) => {
        if (!uniquePincodes.has(pincode.pincode)) {
          uniquePincodes.add(pincode.pincode);
          uniqueOptions.push({
            value: pincode.pincode,
            label: pincode.pincode,
          });
        }
      });

      uniqueOptions.sort((a, b) => a.value - b.value);
      setPincodeOptions(uniqueOptions);
    }

    if (!presentState) {
      setPresentCityOptions([]);
      setPresentPincodeOptions([]);
    } else {
      const filteredCities = cities.filter(
        (city) => city.State_name === presentState
      );

      const presentCityOptions = filteredCities.map((city) => ({
        value: city.name,
        label: city.name,
      }));
      setPresentCityOptions(presentCityOptions);

      const filteredPincodes = pincodenumber.filter(
        (pincode) => pincode.state === presentState.toUpperCase()
      );

      const uniquePincodes = new Set();
      const uniqueOptions = [];
      filteredPincodes.forEach((pincode) => {
        if (!uniquePincodes.has(pincode.pincode)) {
          uniquePincodes.add(pincode.pincode);
          uniqueOptions.push({
            value: pincode.pincode,
            label: pincode.pincode,
          });
        }
      });

      uniqueOptions.sort((a, b) => a.value - b.value);
      setPresentPincodeOptions(uniqueOptions);
    }

    if (!officeState) {
      setOfficeCityOptions([]);
      setOfficePincodeOptions([]);
    } else {
      const filteredCities = cities.filter(
        (city) => city.State_name === officeState
      );

      const officeCityOptions = filteredCities.map((city) => ({
        value: city.name,
        label: city.name,
      }));
      setOfficeCityOptions(officeCityOptions);

      const filteredPincodes = pincodenumber.filter(
        (pincode) => pincode.state === officeState.toUpperCase()
      );

      const uniquePincodes = new Set();
      const uniqueOptions = [];
      filteredPincodes.forEach((pincode) => {
        if (!uniquePincodes.has(pincode.pincode)) {
          uniquePincodes.add(pincode.pincode);
          uniqueOptions.push({
            value: pincode.pincode,
            label: pincode.pincode,
          });
        }
      });

      uniqueOptions.sort((a, b) => a.value - b.value);
      setOfficePincodeOptions(uniqueOptions);
    }
  }, [
    selectedState,
    presentState,
    officeState,
    cities,
    pincodenumber,
  ]);

  const handleStateChange = (selectedOption) => {
    setSelectedState(selectedOption?.value || null);
    setValue("state", selectedOption?.value || "");
  };

  const getSelectedStateValue = () => {
    return stateOptions.find((option) => option.value === selectedState);
  };

  const handlePresentStateChange = (selectedOption) => {
    setPresentState(selectedOption?.value || null);
    setValue("present_state", selectedOption?.value || "");
  };

  const getSelectedPresentStateValue = () => {
    return stateOptions.find((option) => option.value === presentState);
  };

  const handleOfficeStateChange = (selectedOption) => {
    setOfficeState(selectedOption?.value || null);
    setValue("office_state", selectedOption?.value || "");
  };

  const getSelectedOfficeStateValue = () => {
    return stateOptions.find((option) => option.value === officeState);
  };

  const handleCompanyChange = (selectedOption) => {
    setSelectedCompanyId(selectedOption.value || null);
    setCompanyName("company_name", selectedOption.label || "")
    setValue("company_name", selectedOption.label || "");
  };

  const getSelectedCompanyValue = () => {
    return companyLists.find((option) => option.label === companyName);
  };

  const checkEmail = async (email) => {
    if (email) {
      try {
        const data = await getPersonalLoanByEmail(email);
        setEmailExists(Boolean(data));
      } catch (error) {
        setEmailExists(false);
      }
    }
  };

  const checkMobile = async (mobile) => {
    if (mobile) {
      try {
        const data = await getPersonalLoanByMobile(mobile);
        setMobileExists(Boolean(data));
      } catch (error) {
        setMobileExists(false);
      }
    }
  };

  const handleNextStep = async () => {
    const isStepValid = await trigger();
    if (isStepValid) {
      if (emailExists) {
        toast.error("Email already exists. Please use a different email.");
        return;
      }
      if (mobileExists) {
        toast.error(
          "Mobile number already exists. Please use a different mobile number."
        );
        return;
      }
      setActiveStep((prevStep) => prevStep + 1);
    }
  };

  const handleFileChange = (event) => {
    const { name, files } = event.target;
    if (files.length > 0) {
      setFiles((prev) => ({
        ...prev,
        [name]: files.length > 0 ? files[0] : null,
      }));
    }
  };

  const handleClearFile = (name) => {
    if (fileRefs[name] && fileRefs[name].current) {
      fileRefs[name].current.value = null;
      setFiles((prev) => ({
        ...prev,
        [name]: null,
      }));
    }
  };

  const handleCompanyButtonClick = () => {
    setIsViewModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsViewModalOpen(false);
  };

  const onSubmit = async (data) => {
    setLoading(true);
    const mobile = localStorage.getItem("verifiedMobile");
    const name = data.name;

    try {
      if (!isLoggedIn) {
        // Not logged in: create or get customer
        let adminId;
        let adminName = name;

        try {
          const customerResponse = await createOrGetCustomer({ mobile, name });
          adminId = customerResponse.adminId;
          adminName = customerResponse.name || name;
          // toast.info(customerResponse.isNew ? "Customer created successfully!" : "Customer already exists!");
        } catch (err) {
          throw err;
        }

        // Set created_by and created_id for the home loan
        data.created_by = adminName;
        data.created_id = adminId;
        data.status = data.status || "open";
        data.assigned_to = data.assigned_to || "";

      } else {
        data.created_by = adminName;
        data.created_id = adminId;
      }

      const formData = new FormData();
      Object.keys(data).forEach((key) => {
        if (
          key === "pan" ||
          key === "aadhar" ||
          key === "photo" ||
          key === "pay_slip" ||
          key === "account_statement" ||
          key === "others"
        ) {
          formData.append(key, data[key][0]);
        } else {
          formData.append(key, data[key]);
        }
      });

      const response = await createPersonalLoan(formData);
      toast.success("Personal loan created successfully!");
      setTimeout(() => {
        navigate(isLoggedIn ? "/peraonalloanlist" : "/");
      }, 2000);
    } catch (error) {
      setLoading(false);
      const errorMessage = error.response?.data?.message;
      console.error("Error submitting personal loan:", errorMessage || error);
      toast.error("Failed to submit loan application. Please try again.");
    }
  };

  const email = watch("email");
  const mobile = watch("mobile");
  const dob = watch('dob');

  React.useEffect(() => {
    if (email) {
      checkEmail(email);
    }
  }, [email]);

  React.useEffect(() => {
    if (mobile) {
      checkMobile(mobile);
    }
  }, [mobile]);

  useEffect(() => {
    if (dob) {
      const birthDate = new Date(dob);
      const today = new Date();
      let age = today.getFullYear() - birthDate.getFullYear();
      const monthDifference = today.getMonth() - birthDate.getMonth();

      if (monthDifference < 0 || (monthDifference === 0 && today.getDate() < birthDate.getDate())) {
        age--;
      }

      if (age >= 0) {
        setValue('age', age);
      } else {
        setValue('age', '');
      }
    }
  }, [dob, setValue]);

  const handleGoBack = () => {
    if (isLoggedIn) {
      navigate("/personalloanlist");
    } else {
      navigate("/");
    }
  };

  return (
    <div className="container">
      {activeStep === 0 && (
        <div className="edit-back-icon">
          <div className="edit-back-text" onClick={handleGoBack}>
            &lt; Go Back
          </div>
        </div>
      )}
      <h2 className="my-4">Personal Loan</h2>
      <FormProvider {...methods}>
        <form onSubmit={handleSubmit(onSubmit)} className="form-group">
          <Stepper
            activeStep={activeStep}
            alternativeLabel
            className="stepper-container"
          >
            {steps.map((label) => (
              <Step key={label}>
                <StepLabel>{label}</StepLabel>
              </Step>
            ))}
          </Stepper>
          <div className="form-content">
            {activeStep === 0 && (
              <div className="sections personal-details-sections">
                <h4>Personal Details</h4>
                <Row>
                  <Col md={6}>
                    <FormInput
                      name="name"
                      label="Name"
                      registerOptions={validationRules.name}
                      error={errors.name?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="dob"
                      label="Date of Birth"
                      type="date"
                      registerOptions={{
                        required: "Date of Birth is required",
                        validate: {
                          isOldEnough: (value) => {
                            const today = new Date();
                            const minAgeDate = new Date();
                            const maxAgeDate = new Date();
                            minAgeDate.setFullYear(today.getFullYear() - 21);
                            maxAgeDate.setFullYear(today.getFullYear() - 58);
                            return (
                              (new Date(value) <= minAgeDate &&
                                new Date(value) >= maxAgeDate) ||
                              "Choose age from 21 to 58"
                            );
                          },
                          isNotFutureDate: (value) => {
                            return (
                              new Date(value) <= new Date() ||
                              "Date of Birth cannot be in the future"
                            );
                          },
                        },
                      }}
                      error={errors.dob?.message}
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <FormInput name="age" label="Age" type="number" readOnly />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="mobile"
                      label="Mobile"
                      type="tel"
                      registerOptions={validationRules.mobile}
                      error={
                        mobileExists
                          ? "Mobile number already exists"
                          : errors.mobile?.message
                      }
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <FormInput
                      name="email"
                      label="Personal Email ID"
                      registerOptions={validationRules.email}
                      error={errors.email?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="mother_name"
                      label="Mother Name"
                      registerOptions={validationRules.fieldRequired(
                        "Mother Name"
                      )}
                      error={errors.name?.message}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col md={6}>
                    <FormInput
                      name="father_name"
                      label="Father Name"
                      registerOptions={validationRules.fieldRequired(
                        "Father Name"
                      )}
                      error={errors.name?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <DropDownInput
                      name="residence_type"
                      label="Residence Type"
                      options={[
                        { value: "Owned", label: "Owned" },
                        { value: "Rent", label: "Rent" },
                        {
                          value: "OwnedByMe/Spouse",
                          label: "Owned by Me / Spouse",
                        },
                        { value: "OwnedbyMyParents", label: "Owned by My Parents" },
                        { value: "PG/Hostel", label: "PG / Hostel" },
                        { value: "CompanyProvide", label: "Company Provide" },
                        {
                          value: "BachelorAccommodation",
                          label: "Bachelor Accommodation",
                        },
                        { value: "Others", label: "Others" },
                      ]}
                      registerOptions={{
                        required: "Residence Type is required",
                      }}
                      error={errors.residence_type?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <DropDownInput
                      name="maritalStatus"
                      label="Marital Status"
                      options={[
                        { value: "single", label: "Single" },
                        { value: "married", label: "Married" },
                        { value: "divorced", label: "Divorced" },
                      ]}
                      registerOptions={{
                        required: "Status is required",
                        onChange: (e) => {
                          setValue("maritalStatus", e.target.value);
                        },
                      }}
                      error={errors.maritalStatus?.message}
                    />
                  </Col>

                  {watch("maritalStatus") === "married" && (
                    <Col md={6}>
                      <FormInput
                        name="spouse_name"
                        label="Spouse Name"
                        registerOptions={validationRules.fieldRequired(
                          "Spouse Name"
                        )}
                        error={errors.spouse_name?.message}
                      />
                    </Col>
                  )}

                  <Col md={6}>
                    <FormInput
                      name="address"
                      label="Present Staying Address"
                      registerOptions={{
                        required: "Present Address is required",
                      }}
                      error={errors.address?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="landmark"
                      label="Landmark"
                      type="text"
                      registerOptions={{ required: "Landmark is required" }}
                      error={errors.landmark?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <SelectInput
                      name="state"
                      label="State"
                      options={stateOptions}
                      value={getSelectedStateValue()}
                      registerOptions={{ required: "State is required" }}
                      onChange={handleStateChange}
                      error={errors.state?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <SelectInput
                      name="city"
                      label="City"
                      options={cityOptions}
                      registerOptions={{ required: "City is required" }}
                      error={errors.city?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <SelectInput
                      name="pincode"
                      label="Pincode"
                      options={pincodeOptions}
                      registerOptions={{ required: "Pincode is required" }}
                    />
                  </Col>
                  <Col md={6}>
                    <DropDownInput
                      name="present_address_adhaar"
                      label="Is your Present Address as per Aadhaar"
                      options={[
                        { value: "Yes", label: "Yes" },
                        { value: "No", label: "No" },
                      ]}
                      registerOptions={{
                        required: "This selection is required",
                      }}
                      error={errors.present_address_adhaar?.message}
                    />
                  </Col>

                  {watch("present_address_adhaar") === "No" && (
                    <>
                      <Col md={6}>
                        <FormInput
                          name="present_address"
                          label="Present Address"
                          registerOptions={{
                            required: "Address is required",
                          }}
                          error={errors.present_address?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <SelectInput
                          name="present_state"
                          label="State"
                          options={stateOptions}
                          value={getSelectedPresentStateValue()}
                          onChange={handlePresentStateChange}
                          registerOptions={{ required: "State is required" }}
                          error={errors.present_state?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <SelectInput
                          name="present_city"
                          label="Current City"
                          options={presentCityOptions}
                          registerOptions={{ required: "City is required" }}
                          error={errors.present_city?.message}
                        />
                      </Col>
                      <Col md={6}>
                        <SelectInput
                          name="present_pincode"
                          label="Pincode"
                          options={presentPincodeOptions}
                          registerOptions={{ required: "Pincode is required" }}
                        />
                      </Col>
                      <Col md={6}>
                        <FormInput
                          name="present_landmark"
                          label="Present Landmark"
                          registerOptions={{ required: "Landmark is required" }}
                          error={errors.present_landmark?.message}
                        />
                      </Col>
                    </>
                  )}
                </Row>
              </div>
            )}
            {activeStep === 1 && (
              <div className="sections requested-loan-details-sections">
                <h4>Income Details</h4>
                <Row>
                  <Col md={6}>
                    <FormInput
                      name="required_loan_amount"
                      label="Required Loan Amount"
                      type="number"
                      registerOptions={validationRules.loanAmount}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="existing_emi_amount"
                      label="Existing EMI"
                      type="number"
                      registerOptions={{
                        required: "This Existing EMI is required",
                      }}
                      error={errors.existing_emi_amount?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <SelectInput
                      name="company_name"
                      label="Working Company Name"
                      options={companyLists}
                      value={getSelectedCompanyValue()}
                      onChange={handleCompanyChange}
                      addButtonLabel="+ Add Company"
                      onAddButtonClick={handleCompanyButtonClick}
                    />
                  </Col>
                  {watch("company_name") === "Others" && (
                      <Col md={6}>
                        <FormInput
                          name="others_company"
                          label="Other's Company Name"
                        />
                      </Col>
                  )}
                  {isLoggedIn && adminRole !==  "customer" &&
                  (watch("company_name") === "Others" || bankLists.length < 1) &&  (
                    <Col md={6}>
                      <SelectInput
                        name="bank_name"
                        label="Bank Name"
                        options={personalLoanBanks}
                      />
                    </Col>
                  )}

                  {isLoggedIn && adminRole !==  "customer" &&
                  (watch("company_name") !== "Others" && bankLists.length > 0) && (
                    <Col md={6}>
                      <SelectInput
                        name="bank_name"
                        label="Bank Name"
                        options={bankLists}
                      />
                    </Col>
                  )}
                  <Col md={6}>
                    <DropDownInput
                      name="company_type"
                      label="Company Type"
                      options={[
                        {
                          value: "PrivateLimited",
                          label: "Private Limited",
                        },
                        { value: "PublicLimited", label: "Public Limited" },
                        { value: "State", label: "State Government" },
                        { value: "CentralGovt", label: "Central Government" },
                        {
                          value: "Proprietorship",
                          label: "Proprietorship",
                        },
                        { value: "Partnership", label: "Partnership" },
                        { value: "LLP", label: "LLP" },
                        { value: "Others", label: "Others" },
                      ]}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="type_your_designation"
                      label=" Type Your Designation"
                      registerOptions={validationRules.fieldRequired(
                        "Type Your Designation"
                      )}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="net_salary"
                      label="Net Salary"
                      type="number"
                      registerOptions={{
                        required: "Net Salary is required",
                        validate: (value) =>
                          value >= 15000 || "Net Salary must allowed 15,000",
                      }}
                      error={errors.salary?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <DropDownInput
                      name="is_pf_deducted"
                      label="Are You Looking for Balance Transfer?"
                      options={[
                        { value: "Yes", label: "Yes" },
                        { value: "No", label: "No" },
                      ]}
                      registerOptions={{
                        required: "Select PF Deduction Status",
                      }}
                      error={errors.is_pf_deducted?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="total_experience"
                      label="Total years of Experience"
                      registerOptions={{ required: "Expirenced is required" }}
                      error={errors.total_experience?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="office_address"
                      label="Office Address"
                      registerOptions={{ required: "Enter Address" }}
                      error={errors.address?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="office_landmark"
                      label="Office Landmark"
                      registerOptions={{ required: "Landmark is required" }}
                      error={errors.office_landmark?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <SelectInput
                      name="office_state"
                      label="State"
                      value={getSelectedOfficeStateValue()}
                      onChange={handleOfficeStateChange}
                      options={stateOptions}
                      registerOptions={{ required: "State is required" }}
                      error={errors.office_state?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <SelectInput
                      name="office_city"
                      label="City"
                      options={officeCityOptions}
                      registerOptions={{ required: "City is required" }}
                      error={errors.office_city?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <SelectInput
                      name="office_pincode"
                      label="Pincode"
                      options={officePincodeOptions}
                      registerOptions={{ required: "Pincode is required" }}
                      error={errors.office_pincode?.message}
                    />
                  </Col>
                  <Col md={6}>
                    <DropDownInput
                      name="add_reference"
                      label="Add Reference"
                      options={[
                        { value: "Colleague", label: "Colleague" },
                        { value: "Relative", label: "Relative" },
                      ]}
                    />
                  </Col>
                </Row>

                <Row>
                  <h4>Reference Details</h4>
                  <Col md={6}>
                    <FormInput name="reference_name" label="Name" />
                  </Col>
                  <Col md={6}>
                    <FormInput
                      name="reference_mobile"
                      label="Mobile"
                      type="tel"
                    />
                  </Col>
                </Row>

                <Row>
                  <Col md={6}>
                    <FormInput name="reference_address" label="Address" />
                  </Col>
                  <Col md={6}>
                    <FormInput name="reference_location" label="Location" />
                  </Col>
                </Row>
              </div>
            )}

            {activeStep === 2 && (
              <div className="sections financial-details-sections">
                <h4>Please Upload Clear Copy</h4>
                <div className="form-row">
                  <div className="sections document-upload-sections">
                    <div className="document-upload-group create-document">
                      <label htmlFor="pan" className="document-label required">
                        Photo
                      </label>
                      <div className="document-file-container">
                        <input
                          name="photo"
                          label="Photo"
                          type="file"
                          className="form-control-file"
                          {...methods.register("photo", {
                            required: "Photo is required",
                            onChange: (e) => handleFileChange(e),
                          })}
                          ref={(e) => {
                            methods.register("photo").ref(e);
                            fileRefs.photo.current = e;
                          }}
                        />
                        {files.photo && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("photo")}
                          />
                        )}
                      </div>
                      {errors.photo && (
                        <span className="error-message">
                          {errors.photo.message}
                        </span>
                      )}
                    </div>
                    <div className="document-upload-group create-document">
                      <div className="document-label-container">
                        <label
                          htmlFor="aadhar"
                          className="document-label required"
                        >
                          Aadhaar /eAadhaar
                        </label>
                      </div>
                      <div className="document-file-container">
                        <input
                          type="file"
                          id="aadhar"
                          name="aadhar"
                          className="form-control-file"
                          {...methods.register("aadhar", {
                            required: "Aadhaar Card is required",
                            onChange: (e) => handleFileChange(e),
                          })}
                          ref={(e) => {
                            methods.register("aadhar").ref(e);
                            fileRefs.aadhar.current = e;
                          }}
                        />
                        {files.aadhar && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("aadhar")}
                          />
                        )}
                      </div>
                      {errors.aadhar && (
                        <span className="error-message">
                          {errors.aadhar.message}
                        </span>
                      )}
                    </div>
                    <div className="document-upload-group create-document">
                      <label htmlFor="pan" className="document-label required">
                        PAN Card
                      </label>
                      <div className="document-file-container">
                        <input
                          id="pan"
                          name="pan"
                          type="file"
                          className="form-control-file"
                          {...methods.register("pan", {
                            required: "PAN Card is required",
                            onChange: (e) => handleFileChange(e), // merge your custom onChange
                          })}
                          ref={(e) => {
                            methods.register("pan").ref(e); // react-hook-form ref
                            fileRefs.pan.current = e;
                          }}
                        />
                        {files.pan && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("pan")}
                          />
                        )}
                      </div>
                      {errors.pan && (
                        <span className="error-message">
                          {errors.pan.message}
                        </span>
                      )}
                    </div>
                    <div className="document-upload-group create-document">
                      <label htmlFor="pan" className="document-label">
                        Pay Slip (Last 3 Months)
                      </label>
                      <div className="document-file-container">
                        <input
                          id="pay_slip"
                          name="pay_slip"
                          label=" Pay Slip"
                          type="file"
                          className="form-control-file"
                          {...methods.register("pay_slip", {
                            onChange: (e) => handleFileChange(e),
                          })}
                          ref={(e) => {
                            methods.register("pay_slip").ref(e);
                            fileRefs.pay_slip.current = e;
                          }}
                        />
                        {files.pay_slip && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("pay_slip")}
                          />
                        )}
                      </div>
                    </div>
                    <div className="document-upload-group create-document">
                      <label htmlFor="pan" className="document-label required">
                        Account Statement (Last 6 Month )
                      </label>
                      <div className="document-file-container">
                        <input
                          name="account_statement"
                          label="6 Month Account Statement"
                          type="file"
                          id="account_statement"
                          className="form-control-file"
                          accept=".pdf"
                          {...methods.register("account_statement", {
                            required: "Account Statement is required",
                            onChange: (e) => handleFileChange(e),
                          })}
                          ref={(e) => {
                            methods.register("account_statement").ref(e);
                            fileRefs.account_statement.current = e;
                          }}
                        />
                        {files.account_statement && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("account_statement")}
                          />
                        )}
                      </div>
                      <span className="file-upload-message">
                        Upload only PDF files & without password
                      </span>
                      {errors.account_statement && (
                        <span className="error-message">
                          {errors.account_statement.message}
                        </span>
                      )}
                    </div>
                    <div className="document-upload-group create-document">
                      <label htmlFor="others" className="document-label">
                        Others
                      </label>
                      <Col md={12} className="document-dropdown-file">
                        <DropDownInput
                          name="Other"
                          options={[
                            { value: "Employee ID", label: "Employee ID" },
                            { value: "Form16", label: "Form 16" },
                            { value: "Form26AS", label: "Form 26 AS" },
                            {
                              value: "Previous Loan Statement",
                              label: "Previous Loan Statement",
                            },
                          ]}
                        />
                      </Col>
                      <div className="document-file-container">
                        <input
                          id="others"
                          name="others"
                          type="file"
                          className="form-control-file"
                          {...methods.register("others", {
                            onChange: (e) => handleFileChange(e),
                          })}
                          ref={(e) => {
                            methods.register("others").ref(e);
                            fileRefs.others.current = e;
                          }}
                        />
                        {files.others && (
                          <FaTrashAlt
                            className="trash-icon"
                            title="Remove file"
                            onClick={() => handleClearFile("others")}
                          />
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            )}
          </div>
          <div className="button-container mt-4 text-center">
            {activeStep > 0 && (
              <Button
                variant="secondary"
                onClick={() => handleStepChange(activeStep - 1)}
                className="custom-back-button me-2"
              >
                Go Back
              </Button>
            )}
            {activeStep < steps.length - 1 && (
              <Button
                variant="primary"
                onClick={handleNextStep}
                className="custom-next-button me-2"
              >
                Next
              </Button>
            )}
            {activeStep === steps.length - 1 && (
              <Button
                variant="success"
                type="submit"
                className="custom-submit-button"
              >
                {loading ? "Processing..." : "Submit"}
              </Button>
            )}
          </div>
        </form>
      </FormProvider>
      <CreateCompanyModal           
        isOpen={isViewModalOpen}
        onClose={handleCloseModal}
        onCompanyCreated={fetchCompanies} 
      />
      <ToastContainer />
    </div>
  );
};

export default CreatePersonalForm;